import React from "react";
import styles from "./CircularProgress.module.css";
import CProgress  from '@mui/material/CircularProgress';



const CircularProgress = ({open}) => {
  
  if(!open) return null;

  return (
    <div className={styles.overlay}>
      <CProgress />
    </div>
  );
};


export default CircularProgress;